import useQuery from '@shared/hooks/src/useQuery'
import API from '@shared/services/src/API'
import { QK } from '@shared/utils'

export function usePatientAssessments(patientId, query, options = {}) {
  return useQuery({
    queryKey: QK.patients.id(patientId).assessments.list(query),
    queryFn: () => API.patients.id(patientId).assessments.list(query),
    ...options,
  })
}
